import React, { Component } from 'react';
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';

import { FormattedMessage, injectIntl } from "react-intl";
import { toast } from 'react-toastify';
import Picture from '../../components/Picture'
import { formatPhone } from '../../helpers/format'
import MetaTags from '../../components/SEO/MetaTags'
import { handleRequestError, Request } from '../../helpers/request'
import { businessUnitOptions } from '../../helpers/select'
import LocaleLink, { addLocalePrefix } from '../../components/Routes/LocaleLink'


class FormCooptationPage extends Component
{
    state = {
        contact_firstname: '',
        contact_lastname: '',
        contact_phone: '',
        contact_email: '',
        display_contact_form: true,
        coopted_firstname: '',
        coopted_lastname: '',
        coopted_phone: '',
        coopted_email: '',
        coopted_mission_name: '',
        business_unit: null,
        conditions_accepted: false,
        loading: false
    };

    componentDidMount() {
        if (this.props.location.state && this.props.location.state.offer) {

            const {offer} = this.props.location.state;

            this.setState({
                business_unit: offer.business_unit,
                coopted_mission_name: offer.title,
            });
        }
    }

    submitContactForm(e) {
        e.preventDefault();
        this.setState({ display_contact_form: false });
    }

    submit(e) {

        e.preventDefault();

        const {
            contact_firstname,
            contact_lastname,
            contact_phone,
            contact_email,
            coopted_firstname,
            coopted_lastname,
            coopted_phone,
            coopted_email,
            coopted_mission_name,
            business_unit
        } = this.state;

        const { intl } = this.props;
        this.setState({ loading: true });

        let uri = 'cooption/submit';

        if (this.props.location.state && this.props.location.state.offer) {
            uri = 'cooption/submit/' + this.props.location.state.offer.id;
        }

        Request.post(uri, {
            contact_firstname,
            contact_lastname,
            contact_phone,
            contact_email,
            coopted_firstname,
            coopted_lastname,
            coopted_phone,
            coopted_email,
            coopted_mission_name,
            business_unit
        })
            .then(() => {
                toast.success(
                    intl.formatMessage({
                        id: "portfolio.form_contact.message_sent",
                        defaultMessage: "Votre message a bien été envoyé."
                    })
                );
                this.setState({ loading: false });
                this.props.history.push(addLocalePrefix('/'));
            })
            .catch((e) => {
                handleRequestError(e);
                this.setState({ loading: false });
            });
    }

    toggleConditionsAccepted() {
        this.setState({ conditions_accepted: !this.state.conditions_accepted });
    }

    render() {
        return (
            <div className="form-cooptation-page">

                <MetaTags page="cooptation" />

                {
                    this.state.display_contact_form ?
                        this.renderContactSection() :
                        this.renderCooptedSection()
                }
            </div>
        )
    }

    renderContactSection() {
        const { intl } = this.props;

        return (
            <section className="coupon-form">
                <Container>
                    <div className="form-head">
                        <h1 className="line-heading">
                            <FormattedMessage
                                id="portfolio.form_cooptation1.title"
                                defaultMessage="Nous vous offrons un bon d’achat Amazon d’une valeur de 500€
                                si votre connaissance est recrutée&nbsp;!"
                            />
                        </h1>
                        <p>
                            <FormattedMessage
                                id="portfolio.form_cooptation1.subtitle"
                                defaultMessage="Si le candidat coopté passe avec succès sa période d’essai, vous recevrez votre récompense directement par mail."
                            />
                        </p>
                    </div>
                    <div className="coupon-form-wrap">
                        <Form onSubmit={(e) => this.submitContactForm(e)}>
                            <h2>
                                <FormattedMessage
                                    id="portfolio.form_cooptation1.form.title"
                                    defaultMessage="Vos coordonnées 1/2"
                                />
                            </h2>
                            <div className="fields-row">
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation1.firstname.label"
                                            defaultMessage="Prénom*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation1.firstname.placeholder",
                                                defaultMessage: "Pierre"
                                            })
                                        }
                                        value={this.state.contact_firstname}
                                        onChange={(e) => this.setState({ contact_firstname: e.target.value })}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation1.lastname.label"
                                            defaultMessage="Nom*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation1.lastname.placeholder",
                                                defaultMessage: "Durand"
                                            })
                                        }
                                        value={this.state.contact_lastname}
                                        onChange={(e) => this.setState({ contact_lastname: e.target.value })}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation1.phone.label"
                                            defaultMessage="Téléphone*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="tel"
                                        pattern="([+]?[0-9]+)?"
                                        className="input-field"
                                        id="contact_phone"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation1.phone.placeholder",
                                                defaultMessage: "Format : (+33)0123456789"
                                            })
                                        }
                                        value={this.state.contact_phone}
                                        onChange={(e) => this.setState({contact_phone: formatPhone(e)})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation1.email.label"
                                            defaultMessage="Email*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="email"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation1.email.placeholder",
                                                defaultMessage: "Pour vous écrire"
                                            })
                                        }
                                        value={this.state.contact_email}
                                        onChange={(e) => this.setState({ contact_email: e.target.value })}
                                    />
                                </FormGroup>
                            </div>
                            <div className="learn-block">
                                <div className="learn-head">
                                    <Picture
                                        src={require("../../../images/number.png")}
                                        webp={require("../../../images/number.webp")} />
                                </div>
                            </div>
                            <div className="btn-wrap">
                                <Button
                                    className="btn btn-primary"
                                >
                                    <FormattedMessage
                                        id="portfolio.form_cooptation1.button"
                                        defaultMessage="Suivant"
                                    />
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Container>
            </section>
        )
    }

    renderCooptedSection() {
        const { intl } = this.props;

        return (
            <section className="referal-form">
                <Container>
                    <div className="form-head">
                        <h1 className="line-heading">
                            <FormattedMessage
                                id="portfolio.form_cooptation2.title"
                                defaultMessage="JE CONNAIS LE TALENT PARFAIT"
                            />
                        </h1>
                    </div>
                    <div className="referal-form-wrap">
                        <Form onSubmit={(e) => this.submit(e)}>
                            <h2>
                                <FormattedMessage
                                    id="portfolio.form_cooptation2.form.title"
                                    defaultMessage="LES COORDONNéES DE VOTRE AMI 2/2"
                                />
                            </h2>
                            <div className="fields-row">
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation2.firstname.label"
                                            defaultMessage="Prénom*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation2.firstname.placeholder",
                                                defaultMessage: "Pierre"
                                            })
                                        }
                                        value={this.state.coopted_firstname}
                                        onChange={(e) => this.setState({ coopted_firstname: e.target.value })}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation2.lastname.label"
                                            defaultMessage="Nom*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation2.lastname.placeholder",
                                                defaultMessage: "Durand"
                                            })
                                        }
                                        value={this.state.coopted_lastname}
                                        onChange={(e) => this.setState({ coopted_lastname: e.target.value })}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation2.phone.label"
                                            defaultMessage="Téléphone*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="tel"
                                        pattern="([+]?[0-9]+)?"
                                        className="input-field"
                                        id="coopted_phone"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation2.phone.placeholder",
                                                defaultMessage: "Format : (+33)0123456789"
                                            })
                                        }
                                        value={this.state.coopted_phone}
                                        onChange={(e) => this.setState({coopted_phone: formatPhone(e)})}
                                    />
                                </FormGroup>
                                <FormGroup>
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation2.email.label"
                                            defaultMessage="Email*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="email"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation2.email.placeholder",
                                                defaultMessage: "Pour vous écrire"
                                            })
                                        }
                                        value={this.state.coopted_email}
                                        onChange={(e) => this.setState({ coopted_email: e.target.value })}
                                    />
                                </FormGroup>
                            </div>

                            <div className="select-fields-row">

                                {this.renderBusinessUnits()}

                                <div className="form-group select-wrap mb-0">
                                    <Label>
                                        <FormattedMessage
                                            id="portfolio.form_cooptation2.position.label"
                                            defaultMessage="Poste souhaité*"
                                        />
                                    </Label>
                                    <Input
                                        required
                                        type="text"
                                        className="input-field"
                                        placeholder={
                                            intl.formatMessage({
                                                id: "portfolio.form_cooptation2.position.placeholder",
                                                defaultMessage: "Ex: Développeur Node.js"
                                            })
                                        }
                                        value={this.state.coopted_mission_name}
                                        onChange={(e) => this.setState({ coopted_mission_name: e.target.value })}
                                    />
                                </div>
                            </div>

                            <div className="btn-wrap checkbox-wrap mt-5">
                                <div className="custom-control primary checkbox-wrap mb-5 warning">
                                    <Input
                                        required
                                        type="checkbox"
                                        className="custom-control-input"
                                        id="posibility"
                                        onChange={() => this.toggleConditionsAccepted()}
                                    />
                                    <Label className="custom-control-label" htmlFor="posibility">
                                        <span className="box-block mr-3"/>
                                        <span className="check-text">
                                            <FormattedMessage
                                                id="portfolio.form.cgu"
                                                defaultMessage="En cochant la case, vous confirmez avoir lu et accepté les conditions d'utilisation de vos données listées {link}."
                                                values={{
                                                    link: (
                                                        <LocaleLink to={'/cgu'} className={'link-cgu'} target='_blank'>
                                                            <FormattedMessage
                                                                id="myurban.header.notifications.new_application_to_job_order.here"
                                                                defaultMessage={'ici'}
                                                            />
                                                        </LocaleLink>
                                                    )
                                                }}/>
                                            </span>
                                    </Label>
                                </div>
                                <Button
                                    className="btn btn-primary"
                                    disabled={this.state.loading}
                                >
                                    <FormattedMessage
                                        id="portfolio.form_cooptation2.button"
                                        defaultMessage="ENVOYER"
                                    />
                                </Button>
                            </div>
                        </Form>
                    </div>
                </Container>
            </section>
        )
    }

    renderBusinessUnits() {
        return (
            <div className="check-list">
                <Label>
                    <FormattedMessage
                        id="portfolio.form_cooptation2.business_unit.label"
                        defaultMessage="Pour quel type de poste souhaites tu postuler ?"
                    />
                </Label>
                <ul>
                    {
                        businessUnitOptions.map((business_unit, key) => {
                            return this.renderBusinessUnit(key, business_unit);
                        })
                    }
                </ul>
            </div>
        )
    }

    renderBusinessUnit(key, business_unit) {
        return (
            <li key={key}>
                <Label className="checkbox-warning-round">
                    <Input
                        required
                        type="radio"
                        name="radio-btn"
                        onChange={() => this.setState({ business_unit: business_unit.value })}
                        checked={this.state.business_unit == business_unit.value}
                    />
                    <span>{business_unit.label}</span>
                </Label>
            </li>
        )
    }
}

export default injectIntl(FormCooptationPage);
